const iconDelivery = '/content/static/img/icon/homeservices/icon-delivery.svg';
const iconVirtualTour = '/content/static/img/icon/homeservices/icon-virtual-tour.svg';
const iconPaperwork = '/content/static/img/icon/homeservices/icon-paperwork.svg';
const iconTestDrive = '/content/static/img/icon/homeservices/icon-test-drive.svg';
const iconDeliveryKbb = '/content/static/img/icon/homeservices/icon-delivery-kbb.svg';
const iconVirtualTourKbb = '/content/static/img/icon/homeservices/icon-virtual-tour-kbb.svg';
const iconPaperworkKbb = '/content/static/img/icon/homeservices/icon-paperwork-kbb.svg';
const iconTestDriveKbb = '/content/static/img/icon/homeservices/icon-test-drive-kbb.svg';

/* home services in this order because first a customer would like to see the car, then test the car, then buy the car */
export default {
  virtualTour: {
    content: 'Get introduced to the car.',
    iconSrcatc: iconVirtualTour,
    iconSrcford: iconVirtualTour,
    iconSrckbb: iconVirtualTourKbb,
    name: 'virtualTour',
    title: 'Video Walkaround',
    moreInfo: 'Experience the car via video chat and ask your dealer any questions you may have.'
  },
  testDrive: {
    content: 'Take a spin around your home turf. See if you and the car are meant for each other.',
    iconSrcatc: iconTestDrive,
    iconSrcford: iconTestDrive,
    iconSrckbb: iconTestDriveKbb,
    name: 'testDrive',
    title: 'Test Drive',
    moreInfo: 'Test-drive the car on your own turf. Choose the car and the dealer will bring it to you for a no-obligation test drive. For important participation details and mileage limitations, please ask your dealer.'
  },
  vehicleDelivery: {
    content: 'Start the purchase online and have this car delivered to your home.',
    iconSrcatc: iconDelivery,
    iconSrcford: iconDelivery,
    iconSrckbb: iconDeliveryKbb,
    name: 'vehicleDelivery',
    title: 'Delivery',
    filterTitle: 'Local Delivery',
    moreInfo: 'Buy your next car without visiting the dealership, then have it delivered to your door. Our dealers are committed to helping you shop from the comfort of home. For important participation details and mileage limitations, please ask your dealer.',
    filterMoreInfo: 'Get your car delivered to your doorstep from local dealers. (Extra fees may apply.)'
  },
  buyOnline: {
    name: 'buyOnline',
    title: 'Buy Online',
    inventoryListingFooterTitle: 'Buy Online. Clean title. No Hassle',
    moreInfo: 'Skip the dealership and buy 100% online, including hassle free pick up or delivery!',
    filterBadge: 'New!'
  },
  maintenanceValet: {
    content: 'Once you own the car and need service, this dealer will pick it up, do the work and bring your vehicle back.',
    name: 'maintenanceValet',
    title: 'Maintenance from Your Door'
  },
  moneyBackGuarantee: {
    contentDefault: 'Take some time to make sure you love your new purchase – or bring it back within 3 Days and 250 Miles.',
    contentExchangePolicy: 'Take some time to make sure you love your new purchase-or bring it back within %days% days and %miles% miles and exchange it for another vehicle of similar value',
    contentMoneyBackReturn: 'Take some time to make sure you love your new purchase-or bring it back within %days% days and %miles% miles',
    contentMoneyBackAndExchange: 'Take some time to make sure you love your new purchase-or bring it back within %days% days and %miles% miles for a full refund, or exchange for another vehicle of similar value',
    contentLimitedWarranty: 'The dealer has arranged for a third-party limited warranty to cover this vehicle for %days% days / %miles% miles from purchase. This information and coverage is being provided solely by dealer and may be changed or discontinued by dealer at any time. See dealer for full terms and conditions.',
    name: 'peaceOfMind',
    title: 'Peace of Mind'
  },
  accelerate: {
    content: 'Save time when you start your paperwork from home.',
    iconSrcatc: iconPaperwork,
    iconSrcford: iconPaperwork,
    iconSrckbb: iconPaperworkKbb,
    name: 'accelerate',
    title: 'Online Paperwork',
    moreInfo: 'Start the car-buying process online and prep your paperwork ahead of time, so there’s less work to do when you’re ready to test drive your next car.'
  },
  content: {
    heading: 'At Home Services',
    disclaimer: 'All At Home Services must comply with state or local ordinances. For important participation details and mileage limitations, please ask your dealer.',
    disclaimerMoneyBackDefault: '*At least 3 days and 250 miles, but some dealers offer more. Vehicle must be returned in the same condition. Shipping or other fees may not be refunded. Guarantee is provided solely by dealer and may be discontinued at any time.',
    disclaimerMoneyBack: '*Vehicle must be returned in the same condition. Shipping or other fees may not be refunded. Guarantee is provided solely by dealer and may be discontinued at any time. See dealer for full terms and conditions.',
    disclaimerExchangePolicy: 'Exchange your vehicle for another of similar value as solely defined by the dealer. The vehicle must be in its original condition. Shipping or other fees may not be refunded. Guarantee is provided solely by dealer and may be discontinued at any time. See dealer for full terms and conditions.',
    disclaimerMoneyBackAndExchange: 'We will refund payments made if the vehicle is returned within %days% days and %miles% miles in the same condition, or you can exchange for another vehicle of similar value, as solely defined by the dealer. Shipping or other fees may not be refunded. Guarantee is provided solely by dealer and may be discontinued at any time. See dealer for full terms and conditions.'
  }
};